import apiClient from '@admin/lib/auth.client'
import { getCustomHeaders } from '../marketing-landing-page/utils'
import { CohortModel } from '@/types/types'

const customHeaders = getCustomHeaders({ org: 'CJR' })

export const createPublicEnquiryTicket = async (formData: FormData) => {
  const headers = { ...customHeaders }

  const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v1/enquiry/public-enquiry-ticket`, {
    method: 'POST',
    body: formData,
    headers: headers as unknown as Headers,
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || data?.error?.message || 'Something went wrong')
  }
  return data
}

export const getTermsAndConditions = async () => {
  const headers = { ...customHeaders }

  return apiClient.get<{ data: { description: string }[] }, unknown>(
    `${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v1/organizations/${process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID}/terms-and-conditions`,
    {
      customHeaders: headers,
    },
  )
}

export const getAllCohorts = async () => {
  const headers = { ...customHeaders }

  return apiClient.get<{ data: CohortModel[] }, unknown>(
    `${process.env.NEXT_PUBLIC_CJR_API_BASE_URL}/v1/public/cohort/all`,
    {
      customHeaders: headers,
    },
  )
}
